module.exports = __webpack_public_path__ + "static/img/cardcenter_bg.bf202a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cardcenter_bg.png
// module id = uD9a
// module chunks = 1